<template>
  <div class="grid-diff">
    <template v-if="showHeaders">
      <div><b>{{$t('inventory_staging.diff_field')}}</b></div>
      <div><b>{{$t('inventory_staging.diff_from')}}</b></div>
      <div><b>{{$t('inventory_staging.diff_to')}}</b></div>
    </template>
    <template v-for="d of formattedDiffs">
      <div>{{d.k}}</div>
      <div>{{d.o}}</div>
      <div>{{d.n}}</div>
    </template>
  </div>
</template>

<script>

export default {
  name: "StagingDiffs",

  props: {
    diffs: Array,
    showHeaders: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      languages: ['fr', 'en', 'es'],
    }
  },

  computed: {
    formattedDiffs() {
      return this.formatDiffs(this.diffs);
    }
  },

  methods: {
    /* method used in StagingDiffs.vue, do not remove */
    formatDiffs(diffs) {
      let nbHyphens = k => (k.match(/-/g) || []).length;
      return diffs
        .map(({k,o,n}) => ({
          k: this.formatFieldPath(k),
          o: this.formatValue(o),
          n: this.formatValue(n)
        }))
        .sort((r1, r2) => {
          let k1 = r1.k, k2 = r2.k;
          return nbHyphens(k1) !== nbHyphens(k2)
              ? nbHyphens(k1) - nbHyphens(k2)
              : k1.localeCompare(k2)
        })
    },
    translationOrNull(trKey) {
      let translation = this.$t(trKey, {noConsole: true});
      return typeof translation === 'string' && trKey !== translation ? translation : null;
    },

    formatFieldPath(path) {
      let language = null;

      /* extract language from path */
      let isTranslationFieldRegex = new RegExp(`\\.(${this.languages.join('|')})$`);
      let languageMatch = path.match(isTranslationFieldRegex);
      if (languageMatch) {
        path = path.replace(isTranslationFieldRegex, '');
        language = languageMatch[1];
      }

      /* edge cases */
      path = path.replace('.unitPrice', '');

      /* find translation */
      let translated = this.translationOrNull(path)
          || this.translationOrNull(`diff_fields.${path}`)
          || path
              .split('.')
              .map(f => this.translationOrNull(f) || this.translationOrNull(`diff_fields.${f}`) || f)
              .map((f,i) => i === 0 ? f : (f.charAt(0).toLowerCase() + f.slice(1)))
              .join(' - ');

      /* add language to translation */
      if (language) {
        translated = `${translated} (${language})`
      }
      return translated;
    },

    formatValue(value) {
      if (typeof value === 'boolean') {
        value = value ? this.$t('yes') : this.$t('no')
      }
      return value;
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-diff {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;

  > :nth-child(6n+4), :nth-child(6n+5), :nth-child(6n+6) {
    background-color: #dcdcdc;
  }
}
</style>